import { Outlet } from 'react-router-dom';
import Footer from '../components/Footer';
import TopBanner from '../components/TopBanner';
import SideBanners from '../components/SideBanners';
import Header from '../components/Header';
import Navbar from '../components/Navbar';

const LayoutMain = () => {
    return (
        <>
            <TopBanner />
            <SideBanners />
            <Header />
            <Navbar />
            <Outlet />
            <Footer />
        </>
    );
};

export default LayoutMain;
